import { CdkDrag, CdkDragHandle, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { CdkTableModule } from '@angular/cdk/table'
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTreeModule } from '@angular/material/tree'
import { NgModule } from '@angular/core'

export const MATERIAL_MODULES = [
  MatInputModule,
  MatSelectModule,
  MatMenuModule,
  MatDialogModule,
  MatFormFieldModule,
  MatPaginatorModule,
  MatSortModule,
  MatTabsModule,
  MatSlideToggleModule,
  MatIconModule,
  MatExpansionModule,
  CdkTableModule,
  MatTableModule,
  MatButtonModule,
  MatSidenavModule,
  MatCheckboxModule,
  MatChipsModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatDividerModule,
  MatTooltipModule,
  MatTreeModule,
  CdkDrag,
  CdkDragHandle,
  CdkDropList,
  CdkDropListGroup,
]

@NgModule({
  declarations: [],
  imports: [ReactiveFormsModule, FormsModule, CommonModule, ...MATERIAL_MODULES],
  exports: [ReactiveFormsModule, FormsModule, CommonModule, ...MATERIAL_MODULES],
})
export class MaterialModule {}
